__turbopack_context__.v({
  "Actions": "otpNeW_Actions",
  "Author": "otpNeW_Author",
  "Avatar": "otpNeW_Avatar",
  "Body": "otpNeW_Body",
  "BodyLabel": "otpNeW_BodyLabel",
  "Byline": "otpNeW_Byline",
  "Chevron": "otpNeW_Chevron",
  "Chevron--Up": "otpNeW_Chevron--Up",
  "Comment": "otpNeW_Comment",
  "Comment--Active": "otpNeW_Comment--Active",
  "Comment--Faded": "otpNeW_Comment--Faded",
  "Comment--Orphaned": "otpNeW_Comment--Orphaned",
  "Comment--Placed": "otpNeW_Comment--Placed",
  "Comments": "otpNeW_Comments",
  "Composer": "otpNeW_Composer",
  "DangerButton": "otpNeW_DangerButton",
  "Date": "otpNeW_Date",
  "Delete": "otpNeW_Delete",
  "Errors": "otpNeW_Errors",
  "Excerpt": "otpNeW_Excerpt",
  "Excerpt--Faded": "otpNeW_Excerpt--Faded",
  "Field": "otpNeW_Field",
  "Header": "otpNeW_Header",
  "Label": "otpNeW_Label",
  "List": "otpNeW_List",
  "Orphaned": "otpNeW_Orphaned",
  "Person": "otpNeW_Person",
  "Quote": "otpNeW_Quote",
  "Root": "otpNeW_Root",
  "Show": "otpNeW_Show",
  "Text": "otpNeW_Text",
  "TextBox": "otpNeW_TextBox",
  "TextButton": "otpNeW_TextButton",
  "Title": "otpNeW_Title",
  "Toggle": "otpNeW_Toggle",
  "You": "otpNeW_You",
  "skeleton-loading": "otpNeW_skeleton-loading",
});
